<template>
    <div v-if="status !== 'Not Advertising'" v-loading="loading">
        <h2 style="margin-top: 20px;">Addons</h2>
        <table class="table" v-if="addons.length">
            <thead>
            <tr>
                <th>Addon</th>
                <th style="width: 180px;">Price</th>
                <th style="width: 80px;"></th>
                <th style="width: 60px;"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="addon in addons">
                <td><input type="text" class="form-control" v-model="addon.name"></input></td>
                <td><input type="text" class="form-control" v-model="addon.price"></input></td>
                <td>
                    <btn icon="fas fa-cloud-upload-alt" :click="() => saveAddon(addon)">Save</btn>
                </td>
                <td>
                    <btn icon="fas fa-times" cssClass="btn-sm btn-danger" :click="() => removeAddon(addon)"></btn>
                </td>
            </tr>
            </tbody>
        </table>
        <btn icon="fas fa-plus" :click="addAddon">Add Addon</btn>
    </div>
</template>

<script>
export default {
    props: [
        'billing_period_id',
        'status',
    ],
    data() {
        return {
            addons: [],
            loading: false,
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            return axios.get(url(`admin/budget-addon/${this.billing_period_id}/list`))
                        .then(response => {
                            this.addons = _.cloneDeep(response.data);
                            this.loading = false;
                        });
        },
        addAddon() {
            return axios.post(url(`admin/budget-addon/${this.billing_period_id}/add`))
                        .then(response => {
                            return this.refresh();
                        });
        },
        saveAddon(addon) {
            return axios.post(url(`admin/budget-addon/${this.billing_period_id}/addon/${addon.id}/save`), addon)
                        .then(response => {
                            return this.refresh();
                        });
        },
        removeAddon(addon) {
            return axios.post(url(`admin/budget-addon/${this.billing_period_id}/addon/${addon.id}/remove`))
                        .then(response => {
                            return this.refresh();
                        });
        },
    },
    mounted() {
        if (this.status !== 'Not Advertising') {
            this.refresh();
        }
    },
};
</script>
